import '../styles/index.css';
import '../src/plugins'
import '../src/components/proff';

import {initVueTurbolinksWithContext} from '../src/utils/vue-turbolinks'

// FIXME replace with webpacker + dotenv
// https://github.com/rails/webpacker/blob/master/docs/env.md
window.__proffSpa__ = {
  apiBasePath: '',
  s3BasePath: 'https://proff-prod.s3-ap-northeast-1.amazonaws.com'
}

initVueTurbolinksWithContext(require.context('../options/cv-editor', false, /\.ts$/));
